<template>
  <div class="g-format--price">
    <van-overlay :show="showLoading">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
    <div class="commodity_details" v-show="!showLoading">
      <header>
        <swiper
          :options="swiperOption"
          v-if="commoditys.image1s && commoditys.image1s.length > 0"
          class="my-swiper"
        >
          <swiper-slide
            v-for="(item, index) in commoditys.image1s"
            :key="item.imageUrl"
          >
            <!-- <img
              class="swipe-img"
              :style="{'width':windowRatio * imagesRatio[index].width + 'px', 'height':windowRatio * maxhegint + 'px'}"
              :src="item.imageUrl+'?x-oss-process=style/style_detail_banner_img'"
              @click="showImg(index)" object-fit="cover"
            > -->
            <img
              class="swipe-img"
              :style="{ width: 100 + '%', 'max-height': maxHeight + 'px' }"
              :src="
                item.imageUrl + '?x-oss-process=style/style_detail_banner_img'
              "
              @click="showImg(index)"
              object-fit="cover"
            />
            <van-image
              v-if="
                commoditys.goodsActivityInfo &&
                commoditys.goodsActivityInfo.frameImageUrl &&
                index == 0
              "
              @click="showImg(index)"
              class="swipe-back"
              :src="
                commoditys.goodsActivityInfo &&
                commoditys.goodsActivityInfo.coverImageUrl
              "
            />
          </swiper-slide>
          <div
            class="swiper-pagination"
            v-if="swiperOption.autoplay"
            slot="pagination"
          ></div>
        </swiper>
        <div class="swipe_info">
          <div class="item">
            <div class="price">
              <p class="p1">
                <span class="span1">
                  <span class="span11">￥</span>
                  {{ commoditys.price }}
                </span>
                <span class="span2">￥{{ commoditys.markingPrice }}</span>
                <span class="span3">{{ commoditys.discountStr }}</span>
              </p>
              <p class="p2">{{ commoditys.itemName }}</p>
            </div>
            <div></div>
          </div>
          <!-- <div
            v-if="isBessGoodListCome && isbeeUpShelf"
            class="item fx"
            @click="shareGoods"
          >
            <img src="./../../assets/image/brandico.png" alt />
            <p class="fx_img">分享</p>
          </div> -->
        </div>
      </header>
      <div class="details_item">
        <div class="details_img" @click="showinfo = true">
          <img src="./../../assets/image/6.png" />
        </div>
        <div class="details-p">
          <div class="details-cell" @click="show = !show">
            <div>
              选择
              <span class="custom-title">{{ selected.names }}</span>
            </div>
            <img src="@/assets/image/arrow_icon@2x.png" />
          </div>
        </div>
        <!-- <div class="details_bill">
          <div class="p1">
            <span>发货</span>
            <span class="address">广东深圳</span>
          </div>
        </div> -->
        <div class="details">
          <div class="details_barnd">
            <van-image
              :src="commoditys.logoImage && commoditys.logoImage.imageUrl"
              width="60"
              height="40"
            ></van-image>
            <strong>{{ commoditys.branchName }}</strong>
          </div>
        </div>
      </div>
      <div
        class="size-detail"
        v-if="
          commoditys.sizeDetailList && commoditys.sizeDetailList.length != 0
        "
      >
        <div class="size-detail-title">
          <img src="@/assets/image/size-detail-bnd.png" alt="" />
          <div @click="gotoSizeDtl">详细尺码表</div>
        </div>

        <div class="size-detail-table">
          <div
            v-for="(item, idx) in commoditys.sizeDetailList[0]"
            class="size-detail-table-row"
            :key="idx"
          >
            <template v-if="sizeDetailShow || (!sizeDetailShow && idx < 3)">
              <div class="size-detail-table-item"></div>
              <div
                v-for="(items, index) in commoditys.sizeDetailList"
                class="size-detail-table-item"
                 :key="index"
                :style="{
                  width:
                    commoditys.sizeDetailList.length > 5
                      ? '20%'
                      : 100 / commoditys.sizeDetailList.length + '%',
                }"
              >
                <span>{{ items[idx] }}</span>
              </div>
            </template>
          </div>
        </div>

        <div class="size-detail-btn" @click="openSizeDetail">
          {{ sizeDetailShow ? "收起" : "更多" }}
          <img
            src="@/assets/image/arrow_icon@2x.png"
            style="transform: rotate(270deg)"
            :style="{
              transform: sizeDetailShow ? 'rotate(270deg)' : 'rotate(90deg)',
            }"
          />
        </div>
      </div>
      <div class="details_info">
        <div>
          <img src="./../../assets/image/1.png" alt />
        </div>
        <div class="goods_details">
          <img src="./../../assets/image/5.png" alt />
        </div>
        <div
          v-if="commoditys.goodsDetailType == 1"
          v-html="commoditys.info"
          class="html_detail"
        ></div>
        <div v-if="commoditys.goodsDetailType == 2 && commoditys.fixedMode">
          <div
            v-show="
              commoditys.fixedMode && commoditys.fixedMode.front.length > 0
            "
          >
            <!-- <h3 class="h3">商品正面</h3> -->
            <van-image
              :src="i.imageUrl"
              v-for="(i, idx) in commoditys.fixedMode.front"
              :key="idx"
              width="100%"
            ></van-image>
          </div>
          <div
            v-show="
              commoditys.fixedMode && commoditys.fixedMode.back.length > 0
            "
          >
            <!-- <h3 class="h3">商品背面</h3> -->
            <van-image
              :src="i.imageUrl"
              v-for="(i, idx) in commoditys.fixedMode.back"
              :key="idx"
            ></van-image>
          </div>
          <div
            v-show="
              commoditys.fixedMode && commoditys.fixedMode.sides.length > 0
            "
          >
            <!-- <h3 class="h3">商品侧面</h3> -->
            <van-image
              :src="i.imageUrl"
              v-for="(i, idx) in commoditys.fixedMode.sides"
              :key="idx"
            ></van-image>
          </div>
          <div
            v-show="
              commoditys.fixedMode && commoditys.fixedMode.details.length > 0
            "
          >
            <!-- <h3 class="h3">商品细节</h3> -->
            <van-image
              :src="i.imageUrl"
              v-for="(i, idx) in commoditys.fixedMode.details"
              :key="idx"
            ></van-image>
          </div>
          <div
            v-show="
              commoditys.fixedMode && commoditys.fixedMode.brandimg.length > 0
            "
          >
            <!-- <h3 class="h3" style>商品实拍</h3> -->
            <van-image
              :src="i.imageUrl"
              v-for="(i, idx) in commoditys.fixedMode.brandimg"
              :key="idx"
            ></van-image>
          </div>
        </div>
        <div>
          <img src="./../../assets/image/3.png" alt />
        </div>
        <div>
          <img src="./../../assets/image/4.png" alt />
        </div>
      </div>
      <div v-if="!istoolbar">
        <van-goods-action class="goods-action" v-if="!isBessGoodListCome">
          <van-goods-action-button
            color="#F7BE43"
            type="warning"
            text="编辑"
            @click="goEditeFun(commoditys.id)"
          />
          <van-goods-action-button
            :color="$theme.epButtonColor"
            type="danger"
            text="提交审核"
            @click="goApplyFun(commoditys.id)"
          />
        </van-goods-action>
      </div>
      <van-action-sheet v-model="show" title=" ">
        <div class="content">
          <header class="header">
            <van-image
              width="90"
              height="90"
              :src="
                attrs.imageInfo + '?x-oss-process=style/style_detail_select_img'
              "
            >
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
            </van-image>
            <div class="sku_info">
              <p class="sku_price">
                <span v-show="selected.checked">￥{{ attrs.salePrice }}</span>
                <span v-show="!selected.checked"
                  >￥{{ commoditys.minPrice }}-{{ commoditys.maxPrice }}</span
                >
              </p>
              <p class="sku_sum">
                <span v-if="commoditys.seckillType == 0"
                  >库存{{
                    selected.checked ? attrs.stock : commoditys.totalStock
                  }}件</span
                >
              </p>
              <p class="sku_chekc">
                {{ selected.names ? "已选：" + selected.names : "请选择" }}
              </p>
            </div>
          </header>
          <div class="sku-box">
            <div class="suk_attribute">
              <div
                class="attribute_item"
                v-for="(item, index) in commoditys.goodAttributeDTOList"
                :key="index"
              >
                <span class="attribute_title">{{ item.attributeName }}</span>
                <div class="attribute_text">
                  <button
                    v-for="(sub, idx) in item.attributeValues"
                    :key="idx"
                    :class="[
                      !sub.active ? 'disabled' : '',
                      sub.select ? 'active' : '',
                    ]"
                    @click="onAttrClick(sub, index, idx)"
                  >
                    {{ sub.attributeValue }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-action-sheet>

      <van-action-sheet v-model="showinfo">
        <div class="sheep_title">服务说明</div>
        <div class="sheep_contentt">
          <div class="sheep_content_item">
            <p class="size26">100%专柜正品</p>
            <p class="size24 colorcc">
              专柜正品，商场直邮，快递到家，购物安心便捷
            </p>
          </div>
          <div class="sheep_content_item">
            <p class="size26">24小时内发货</p>
            <p class="size24 colorcc">订单支付成功后，保证商品在24小时内发出</p>
          </div>
          <div class="sheep_content_item">
            <p class="size26">7天包退换</p>
            <p class="size24 colorcc">
              不影响二次销售情况下，自收到商品次日起，7天内可无理由退换货（部分品牌及品类除外）
            </p>
          </div>
          <div class="sheep_content_item">
            <p class="size26">关于瑕疵</p>
            <p class="size24 colorcc">
              因生产批次不同，部分产品细节有细微差别，并非质量问题。
            </p>
          </div>
          <div class="sheep_content_item">
            <p class="size26">关于差价</p>
            <p class="size24 colorcc">
              因品牌调控、促销政策调整等原因，部分商品价格会有所浮动，下单以当前页面价格为准，商家不提供差价补偿。
            </p>
          </div>
          <div class="sheep_content_btn">
            <span class="yellow" @click="showinfo = false">知道了</span>
          </div>
        </div>
      </van-action-sheet>
    </div>

    <!--反馈按钮 ver1104 -->
    <div class="feedback-item" v-if="readFeedBack" @click="feedHandler">
      <div class="icon"></div>
    </div>
  </div>
</template>
<script>
import http from "@/utils/axios";
import utils from "@/utils/common";
export default {
  data() {
    return {
      isBessGoodListCome:
        this.$route.query.from == "beeGoodsList" ? true : false,
      isbeeUpShelf: this.$route.query.beeUpShelf == "y" ? true : false,
      userId: this.$route.query.userId || "",
      commoditys: {
        fixedMode: {},
      },
      istoolbar: this.$route.query.toolbar == "false" ? true : false,
      showLoading: true,
      current: 0,
      isquick: "n",
      imageLength: 3,
      sku: {},
      imags: [],
      commodityId: "",
      stepperValue: 1,
      show: false,
      showinfo: false,
      isfollw: false,
      attrs: {},
      isDisable: false,
      queryData: {},
      attrsValues: [],
      imagesRatio: [],
      swiperOption: {
        autoplay: false,
        speed: 1000,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
        },
        autoHeight: false,
      },
      stockData: {},
      selected: { names: "", checked: false },
      windowRatio: window.innerWidth / 750,
      maxhegint: "",
      sizeDetailShow: false,
      maxHeight: "",
      readFeedBack: null, //控制反馈按钮 显示/隐藏  ver1104
    };
  },
  methods: {
    //接口请求 ver1104
    getFeedBackInfo() {
      // let params={}
      console.log(
        "rps--taskQualifications-this.$route.query--",
        this.$route.query
      );
      let id = this.$route.query.id
        ? this.$route.query.id
        : this.$route.query.commodityId;
      //赋值
      this.$set(this, "commodityId", id);
      http({
        url:
          "/order/bizGoodsTask/taskQualifications/" +
          this.commodityId +
          "/STAFF",
        method: "get",
        //parmes: params,
      })
        .then((rps) => {
          console.log("rps--taskQualifications---", rps);
          if (rps.code == 200 && rps.data) {
            this.$set(this, "readFeedBack", rps.data);
          }
        })
        .catch((rps) => {});
    },
    feedHandler() {
      let tp = {
        goodsId: this.commodityId,
        goodsName: this.commoditys.itemName,
        goodsPrice: this.commoditys.price,
        markingPrice: this.commoditys.markingPrice,
      };
      console.log("tp---feedHandler-----", tp);
      utils.nativeMethod({ tm: 3060102, tp: tp });
    },
    //  获取详情
    getDetails() {
      let id = this.$route.query.id
        ? this.$route.query.id
        : this.$route.query.commodityId;
      http({
        url: "item/app/item/" + id,
        method: "get",
      }).then((rps) => {
        this.showLoading = false;
        this.initAttr(rps.data);
        this.commoditys = rps.data;
        if ((rps.data.image1s || []).length > 1) {
          this.swiperOption.autoplay = {
            delay: 3000,
            disableOnInteraction: false, //true 手指触摸之后不再自动轮播 false 反之
          };
        } else {
          this.swiperOption.loop = false;
          this.swiperOption.autoplay = false;
        }
        let imgs = [];
        let heights = {};
        let height;
        let width;
        rps.data.image1s.forEach((item) => {
          imgs.push(item.imageUrl);
          width = item.imageWidth || 0;
          height = item.imageHeight || 0;
          height = height > 1000 ? 1000 : height;
          heights[height] = width;
        });
        height = Math.max.apply(null, Object.keys(heights).map(Number));
        width = heights[height];
        let scale = height / width;
        let clientWidth =
          document.documentElement.clientWidth || document.body.clientWidth;
        this.maxHeight = clientWidth * scale;

        this.imags = imgs;
        this.imageLength = rps.data.image1s.length;
        this.onImageLoad(rps.data.image1s);
      });
    },
    showImg(index) {
      utils.showMaxImg(
        window.encodeURIComponent(JSON.stringify(this.imags)),
        index
      );
    },
    shareGoods() {
      utils.shareGoods("", "", "", "", "goods", this.commoditys.id);
      utils.nativeMethod({
        tm: "3060101",
        tp: {
          branchName: this.commoditys.branchName,
          branchId: this.commoditys.branchNo,
          goodsId: this.commoditys.id,
        },
      });
    },
    onChange(index) {
      this.current = index;
    },
    goEditeFun(id) {
      utils.finishPage();
      utils.goPageByName({
        id: "beeGoods",
        name: "蜜蜂商品管理新增/修改",
        params: { goodsId: id },
      });
    },
    goApplyFun(id) {
      http({
        url: "order/bee/goods/submitAudit",
        method: "post",
        parmes: { goodsId: id },
      })
        .then((rps) => {
          utils.finishPage();
          utils.goPageByName({
            id: "beeGoodsList",
            name: "蜜蜂商品管理列表",
            params: { refesh: "y" },
          });
        })
        .catch(() => {});
    },
    initAttr(data) {
      let specsIndex = {},
        skuIndex = {};

      if (
        (data.goodAttributeDTOList || []).length == 0 ||
        (data.skuStockList || []).length == 0
      ) {
        return;
      }

      //给每个属性加上对应的层级，是否选中状态，是否激活状态
      data.goodAttributeDTOList.forEach((spec, i) => {
        spec.level = i;
        spec.attributeValues.forEach((attr, j) => {
          attr.level = i;
          attr.active = false;
          attr.select = false;
          specsIndex[attr.id] = { level: i, index: j };
        });
      });

      //给每个sku属性加上层级，并找出有库存的sku存储到data.skuList数组中
      data.skuList = [];
      data.skuStockList.forEach((sku) => {
        if (sku.stock) {
          let attrs = [],
            num = [];

          sku.attributeIdList.forEach((id) => {
            let { level, index } = specsIndex[id];
            attrs.push({ id, level, index });
            num[level] = index;
          });

          skuIndex[Number(num.toString().replace(/,/g, ""))] = attrs;

          data.skuList.push({ stock: sku.stock, attrs });
        }
      });

      //获取第一个选中属性组合
      let firstSelected = [];
      let selected = {
        ids: data.skuStockList[0].attributeIdList,
        names: [],
        attrsLength: data.goodAttributeDTOList.length,
      };
      for (let key in skuIndex) {
        firstSelected = skuIndex[key];
        break;
      }
      firstSelected.forEach(({ level, index }) => {
        const attr = data.goodAttributeDTOList[level].attributeValues[index];
        attr.active = true;
        attr.select = true;
        selected.ids[level] = attr.id;
        selected.names[level] = attr.attributeValue;
      });

      this.setSku(selected);
      this.setAttr(data);
    },
    // 属性点击事件
    onAttrClick(sub, index, idx) {
      if (!sub.active) return;
      let specs = this.commoditys.goodAttributeDTOList;
      let selected = { ids: [], names: [], attrsLength: specs.length };

      specs[index].attributeValues.forEach((attr, i) => {
        attr.select = i == idx ? !attr.select : false;
      });

      //获取选中的ids 和 names
      specs.forEach((spec) => {
        spec.attributeValues.forEach((attr) => {
          if (attr.active && attr.select) {
            selected.ids.push(attr.id);
            selected.names.push(attr.attributeValue);
          }
        });
      });

      this.setSku(selected);
      this.setAttr(this.commoditys);
    },
    setSku(selected) {
      const checked = selected.ids.length == selected.attrsLength;
      this.selected.checked = checked && selected.names.length;
      this.selected.names = selected.names.join(",");
      if (!checked) return;

      http({
        url: "item/app/item/find/stockValues",
        method: "post",
        parmes: {
          goodId: this.$route.query.id || this.$route.query.commodityId,
          attributeValue: selected.ids,
        },
      }).then((rps) => {
        if (rps.code === 200) {
          this.attrs = {
            salePrice: rps.data.salePrice,
            stock: rps.data.stock,
            imageInfo: rps.data.imageInfo && rps.data.imageInfo.imageUrl,
            attributeName: rps.data.attributeValueName,
            skuId: rps.data.id,
          };
          if (rps.data.isSellOut === "y") {
            this.attrs.salePrice = "无货";
            this.stock = 0;
          }
          this.stockData = rps.data;
        }
      });
    },
    setAttr(data) {
      data.goodAttributeDTOList.forEach((spec) => {
        let activeIds = [],
          others = [];

        //查找其他层级是否有选中的属性
        data.goodAttributeDTOList.forEach((item) => {
          if (spec.level != item.level) {
            item.attributeValues.forEach((attr) => {
              if (attr.active && attr.select) {
                others.push(attr);
              }
            });
          }
        });

        data.skuList.forEach((sku) => {
          let can = true;
          /**
           * 如果有选中的属性存在， 则要找出当前遍历层级（即spec）与选中属性相关联的sku组合
           * 否则 直接找出与当前遍历层级相关联的sku组合
           */
          for (let selectedAttr of others) {
            let active = false;
            for (let skuAttr of sku.attrs) {
              if (
                selectedAttr.level == skuAttr.level &&
                selectedAttr.id == skuAttr.id
              ) {
                active = true;
                break;
              }
            }
            can = active && can;
          }
          if (can) {
            sku.attrs.forEach((attr) => {
              if (spec.level == attr.level) {
                activeIds.push(attr.id);
              }
            });
          }
        });

        //激活存在activeIds的属性 不存在则置灰
        spec.attributeValues.forEach((attr) => {
          attr.active = activeIds.indexOf(attr.id) != -1;
        });
      });
    },
    onImageLoad(images) {
      var maxhegint = 0;
      this.imagesRatio = images.map((image) => {
        return this.getImageComputed(image);
      });
      this.imagesRatio.forEach((itme) => {
        console.log("itme.height", itme.height, maxhegint);
        if (itme.height > maxhegint) {
          maxhegint = itme.height;
        }
      });
      this.maxhegint = maxhegint;
      console.log("得到的高度是", maxhegint);
    },
    getImageComputed(image) {
      console.log(image);
      let imageRatio = {};
      if (!image.imageWidth || !image.imageHeight) {
        return {
          width: 750,
          height: 1000,
        };
      }
      if (image.imageWidth > 750 && image.imageHeight > 1000) {
        if (image.imageHeight / 1000 > image.imageWidth / 750) {
          imageRatio.width = (
            (image.imageWidth / image.imageHeight) *
            1000
          ).toFixed(0);
          imageRatio.height = 1000;
        } else {
          imageRatio.width = 750;
          imageRatio.height = (
            (image.imageHeight / image.imageWidth) *
            750
          ).toFixed(0);
        }
      } else if (image.imageHeight > 1000) {
        imageRatio.width = (
          (image.imageWidth / image.imageHeight) *
          1000
        ).toFixed(0);
        imageRatio.height = 1000;
      } else if (image.imageWidth <= 750 && image.imageHeight <= 1000) {
        imageRatio.width = image.imageWidth;
        imageRatio.height = image.imageHeight;
      } else {
        imageRatio.width = 750;
        imageRatio.height = (
          (image.imageHeight / image.imageWidth) *
          750
        ).toFixed(0);
      }
      return imageRatio;
    },
    // 打开尺寸表详情
    openSizeDetail() {
      this.sizeDetailShow = !this.sizeDetailShow;
    },
    gotoSizeDtl() {
      let id =
        this.$route.query.id ||
        this.$route.query.commodityId ||
        this.commoditys.id ||
        "";
      this.$router.push({
        path: "/sizeDetail",
        query: {
          id,
        },
      });
    },
  },
  created() {
    if (this.isBessGoodListCome) {
      document.title = "商品详情";
    } else {
      document.title = "商品详情预览";
    }
    (this.istoolbar == this.$route.query.toolbar) == "false" ? true : false;
    this.$loading.hide();
    this.getDetails();
    this.getFeedBackInfo(); //调用函数  ver1104
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.swiper-pagination-bullet {
  background-color: #000000 !important;
  margin-right: 20px !important;
}
/deep/.swiper-pagination-bullet-active {
  background-color: var(--epButtonColor) !important;
}
.commodity_details {
  position: relative;
  background: #fff;
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  /deep/ .van-button__text {
    color: #000;
  }
  /deep/ .van-action-sheet__close {
    z-index: 1;
  }
  /deep/ .swiper-pagination-bullet {
    background-color: #c13c33;
    width: 15px;
    height: 15px;
  }
  .swipe_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 30px;
    .item {
      font-size: 24px;
      .span1 {
        color: #ec6666;
        font-size: 48px;
        display: inline-block;
        font-weight: 500;
        .span11 {
          font-size: 24px;
        }
      }
      .span2 {
        font-size: 24px;
        color: #ccc;
        padding: 0 24px;
        display: inline-block;
        text-decoration: line-through;
      }
      .span3 {
        display: inline-block;
        width: 76px;
        height: 32px;
        border-radius: 10px;
        font-size: 22px;
        font-weight: 500;
        color: #ed3939;
        background: #ffedee;
        text-align: center;
        line-height: 32px;
      }
      .p2 {
        max-width: 620px;
        font-size: 28px;
        color: #333;
        padding-top: 25px;
        font-weight: 500;
      }
    }
    .fx {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #333;
      img {
        width: 40px;
        height: 40px;
      }
      .fx_img {
        text-align: center;
      }
    }
  }
  .details_item {
    .details-p {
      padding: 26px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      color: #999;
      border-top: 10px solid #f7f7f7;
      .details-cell {
        font-size: 24px;
        box-sizing: border-box;
        color: #333;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        font-weight: 500;
        img {
          width: 40px;
          height: 40px;
        }
        .custom-title {
          padding-left: 60px;
          font-weight: 400;
        }
      }
    }
    .details_bill {
      padding: 26px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      color: #333;
      border-top: 10px solid #f7f7f7;
      .p1 {
        display: flex;
        font-weight: 500;
        .address {
          margin-left: 60px;
          font-weight: 400;
        }
      }
    }
    .details {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      color: #333;
      padding: 30px;
      border-top: 10px solid #f7f7f7;
      &:last-child {
        border-bottom: 10px solid #f7f7f7;
      }
      img {
        width: 10px;
        height: 10px;
        vertical-align: middle;
        padding-right: 10px;
      }
      .van-cell {
        padding: 0;
        font-size: 24px;
        color: #999;
      }
      .details_barnd {
        display: flex;
        align-items: center;
        .van-image {
          border: 1px solid #f2f2f2;
        }
        img {
          border: 1px solid #ccc;
          padding: 3px;
        }
        strong {
          color: #000;
          font-weight: 500;
          padding-left: 20px;
        }
      }
      .see_brand {
        p {
          background: #f2d65e;
          border-radius: 30px;
          color: #000;
          padding: 10px 15px;
        }
      }
    }
    .details_img {
      height: 92px;
      border-top: 10px solid #f7f7f7;
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .details_info {
    padding: 30px;
    img {
      max-width: 100%;
    }
    .h3 {
      font-size: 30px;
      text-align: center;
      color: #333;
    }
    .goods_details {
      width: 690px;
      height: 112px;
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
  // 购物车弹窗
  .content {
    padding: 20px 0;
    position: relative;
    .header {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 0 30px;
      .sku_info {
        padding-left: 30px;
        .sku_price {
          color: #ff1c1c;
          font-size: 36px;
          font-weight: bold;
          .size24 {
            font-size: 24px;
          }
        }
        .sku_sum {
          font-size: 24px;
          color: #999;
          padding: 10px 0;
          height: 34px;
        }
        .sku_chekc {
          font-size: 24px;
          color: #333;
          font-weight: 400;
        }
      }
    }
    .sku-box {
      max-height: 60vh;
      overflow-y: auto;
      padding: 0 30px;
    }
    .suk_attribute {
      padding-top: 44px;
      padding-bottom: 50px;
      .attribute_title {
        font-size: 26px;
        color: #333;
        font-weight: 500;
        padding-bottom: 30px;
      }
      .attribute_text {
        display: flex;
        flex-wrap: wrap;
        button {
          display: inline-block;
          height: 56px;
          font-size: 24px;
          padding: 0 40px;
          border: 2px solid #979797;
          border-radius: 10px;
          margin: 10px;
          background: #fff;
          box-sizing: border-box;
        }
        .active {
          background: var(--epButtonColor);
          border-color: var(--epButtonColor);
          color: var(--epTextColor);
        }
        .disabled {
          background: #f1f1f1;
          border-color: #f1f1f1;
          color: #cccccc;
          text-decoration: line-through;
        }
      }
    }
  }
  .sheep_title {
    font-size: 32px;
    color: #000;
    padding-left: 40px;
    padding-top: 64px;
    padding-bottom: 35px;
  }
  .sheep_contentt {
    padding: 0 20px 0 50px;
    .sheep_content_item {
      padding: 10px;
      position: relative;
      .size26 {
        font-size: 24px;
        color: #333;
        padding-bottom: 5px;
      }
      .colorcc {
        font-size: 24px;
        color: #999;
      }
      &::before {
        content: " ";
        height: 10px;
        width: 10px;
        font-size: 100px;
        position: absolute;
        border-radius: 50%;
        left: -20px;
        top: 25px;
        background: var(--epButtonColor);
        color: var(--epButtonColor);
      }
    }
    .sheep_content_btn {
      padding: 40px 0;
      text-align: center;
      .yellow {
        background: var(--epButtonColor);
        font-size: 32px;
        color: var(--epTextColor);
        padding: 20px 12px;
        width: 250px;
        font-weight: bold;
        border-radius: 50px;
        display: inline-block;
      }
    }
  }
  .popup_content {
    padding: 0.5rem;
    position: relative;
    p {
      margin: 0;
    }
  }
  .disable {
    position: absolute;
    width: 100%;
    height: 80px;
    text-align: center;
    background: #ccc;
    color: #fff;
    font-size: 28px;
    bottom: 100px;
    line-height: 80px;
  }
  .custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 12px;
    color: #c13c33;
    background: rgba(0, 0, 0, 0.1);
  }
  .van-swipe-item {
    font-size: 20px;
    text-align: center;
  }
  .html_detail {
    font-size: 28px;
    text-align: center;
  }
  .toolbar-inner {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 80px;
    text-align: center;
    background: #fff;
    .van-button {
      color: #333;
      font-weight: 500;
      width: 320px;
      /deep/.van-button__text {
        color: #333;
      }
    }
  }
}
.share-d {
  width: 100%;
  font-size: 24px;
  position: absolute;
  height: 125px;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  z-index: 10;
  color: #fff;
  .s1 {
    padding-left: 30px;
    padding-right: 30px;
    margin-top: 28px;
    margin-bottom: 26px;
    .s2 {
      padding-left: 29px;
    }
    .s21 {
      display: inline-block;
    }
    .botton {
      border-radius: 0.5rem;
      color: #333;
      font-size: 0.3rem;
      width: 160px;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      margin: 0 10px;
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.size-detail {
  font-size: 22px;
}
.size-detail-title {
  height: 130px;
  position: relative;
  border: 1px dotted #e8e8e8;
}
.size-detail-title div {
  color: #f8a651;
  text-decoration-line: underline;
  position: absolute;
  right: 30px;
  bottom: 29px;
}
.size-detail-table {
  font-size: 22px !important;
  overflow-x: scroll;
  background-color: #fff;
}
.size-detail-table-row {
  width: 100%;
  text-align: center;
  display: flex;
}
.size-detail-table-row:nth-child(1) .size-detail-table-item {
  background-color: #fafafa !important;
  min-height: 54px;
  span {
    white-space: normal;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.size-detail-table-row .size-detail-table-item:nth-child(2) {
  position: absolute;
  background: #fff;
  z-index: 1;
}
.size-detail-table-item {
  flex: 1;
  height: 34px;
  padding: 10px 0;
  min-width: 20%;
  line-height: 28px;
  background: #fff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;

  span {
    margin: auto;
    white-space: nowrap;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.size-detail-btn {
  background: #fafafa;
  text-align: center;
  padding: 12px;
}
.size-detail-btn img {
  height: 30px;
  width: 30px;
  position: relative;
  top: 6px;
}
.goods-action {
  z-index: 10;
}
.swiper-container-autoheight,
.swiper-container-autoheight .swiper-slide {
  text-align: center;
  max-height: 1000px;
  min-height: 562px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;
}
.my-swiper {
  /deep/ .swiper-wrapper {
    align-items: center;
  }
}
.swipe-back {
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}

.feedback-item {
  width: 110px;
  height: 110px;
  position: fixed;
  bottom: 150px;
  right: 30px;
  border-radius: 50%;
  overflow: hidden;
  z-index: 1000;
  .icon {
    display: inline-block;
    width: 110px;
    height: 110px;
    position: absolute;
    top: 0;
    left: 0;
    background: url("../../assets/feed-back-icon.png") no-repeat;
    background-size: 100%;
  }
}
</style>
